import { render, staticRenderFns } from "./WorldMapSvg.vue?vue&type=template&id=7e85aa7f&scoped=true&"
import script from "./WorldMapSvg.vue?vue&type=script&lang=js&"
export * from "./WorldMapSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85aa7f",
  null
  
)

export default component.exports